import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const MonetizacionPage = () => {
  const [activated, setActivated] = useState(false);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const checkActivationStatus = async () => {
    try {
      const res = await fetch("/api/monetizacion/status/", {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access")}`,
        },
      });
      const result = await res.json();
      setActivated(result.activated);

      // Siempre redirige a EarningsPage, activación se hará allá
      navigate("/monetizacion/ganancias");
    } catch (err) {
      console.error("Error al verificar estado de monetización:", err);
    } finally {
      setLoading(false);
    }
  };

  const irAEditarPerfilFuncional = () => {
    navigate("/perfil-funcional");
  };

  useEffect(() => {
    checkActivationStatus();
  }, []);

  if (loading) {
    return <p className="p-6 text-center text-gray-500">Cargando información de monetización...</p>;
  }

  return (
    <div className="max-w-3xl mx-auto px-6 py-10 bg-white rounded-xl shadow-md">
      <h2 className="text-3xl font-bold mb-4 text-center">💰 Monetización del perfil</h2>
      <p className="text-gray-700 text-lg text-center mb-6">
        Activa funciones para monetizar tu actividad en la plataforma:
      </p>

      <ul className="text-gray-800 text-base space-y-3 mb-8">
        <li>📝 Publica contenido exclusivo para seguidores</li>
        <li>📈 Recibe apoyo a través de propinas</li>
        <li>🎥 Participa en eventos o talleres en vivo</li>
        <li>👕 Vende tus productos o servicios</li>
      </ul>

      <div className="flex flex-col sm:flex-row gap-4 justify-center">
        <button
          onClick={() => navigate("/monetizacion/ganancias")} // Solo redirige
          className="bg-yellow-400 hover:bg-yellow-500 text-black font-semibold py-3 px-6 rounded-lg transition"
        >
          ⚙️ Activar monetización
        </button>

        <button
          onClick={irAEditarPerfilFuncional}
          className="bg-blue-500 hover:bg-blue-600 text-white font-semibold py-3 px-6 rounded-lg transition"
        >
          🧠 Editar perfil funcional
        </button>
      </div>
    </div>
  );
};

export default MonetizacionPage;
